import React from "react"
import propTypes from "prop-types"

import Button from "../../../../components/Button"
import Card, { Title, Description } from "../Card"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardEdit,
  InfoCardLabel,
  InfoCardSubtitle
} from "../InfoCard"

const DailyOrWeeklyServicesCard = ({
  services,
  onFormOpen,
  removeItem,
  goals,
  editLink,
  hideDelete
}) => {
  return (
    <Card className="card--yellow-ex-light">
      <Title>Daily or Weekly Services</Title>
      <Description>
        Request services that you need regular assistance with such as home
        cleaning or personal care services.
      </Description>

      <div className="row">
        {services.map(service => {
          return (
            <div key={service.id} className="col-md-10 col-lg-6">
              <InfoCard
                hideDelete={hideDelete}
                onDelete={() => {
                  removeItem(service.id)
                }}
              >
                <div className="row">
                  <div className="col-md-5">
                    <InfoCardItem>
                      <InfoCardLabel>Service</InfoCardLabel>
                      <InfoCardTitle>{service.title}</InfoCardTitle>
                    </InfoCardItem>

                    <InfoCardItem>
                      <InfoCardLabel>Associated Goals</InfoCardLabel>
                      {goals.map((goal, index) => {
                        const key = `goal-${index}`

                        return service.goals.map(sGoal => {
                          if (goal.id === sGoal.id) {
                            return (
                              <InfoCardSubtitle key={key}>
                                {goal.title}
                              </InfoCardSubtitle>
                            )
                          }
                          return null
                        })
                      })}
                    </InfoCardItem>
                  </div>
                  <div className="col-md-7">
                    <InfoCardItem>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <div className="answer-field_label">Days</div>
                            </th>
                            <th>
                              <div className="answer-field_label">Hrs</div>
                            </th>
                            <th>
                              <div className="answer-field_label">Times</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {service.items.map((day, index) => {
                            const id = index

                            return (
                              <tr key={`days-${id}`}>
                                <td>{day.day}</td>
                                <td>{day.num_hours}</td>
                                <td>{`${day.start_time} - ${day.end_time}`}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </InfoCardItem>
                  </div>
                </div>

                <div className="info-card_btns-group">
                  {editLink ? (
                    <>
                      <Button
                        routerLink={{
                          to: `/pre-plan/add-a-service/${service.id}`
                        }}
                        className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Request Support
                      </Button>

                      <InfoCardEdit
                        href={`/pre-plan/add-a-service/${service.id}`}
                      >
                        Edit
                      </InfoCardEdit>
                    </>
                  ) : (
                    <>
                      <Button
                        button={{ type: "button" }}
                        onClick={e => {
                          onFormOpen(e, service.id, 3)
                        }}
                        className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Request Support
                      </Button>

                      <InfoCardEdit
                        onClick={e => {
                          onFormOpen(e, service.id, 3)
                        }}
                        href="/#"
                      >
                        Edit
                      </InfoCardEdit>
                    </>
                  )}
                </div>
              </InfoCard>
            </div>
          )
        })}
      </div>
    </Card>
  )
}

DailyOrWeeklyServicesCard.defaultProps = {
  onFormOpen: () => {},
  removeItem: () => {},
  hideDelete: false,
  editLink: false
}

DailyOrWeeklyServicesCard.propTypes = {
  onFormOpen: propTypes.func,
  removeItem: propTypes.func,
  hideDelete: propTypes.bool,
  editLink: propTypes.bool,
  services: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.oneOfType([propTypes.number, propTypes.string]),
      requiredService: propTypes.string,
      bestFitsRequiredService: propTypes.string,
      daysService: propTypes.arrayOf(propTypes.shape({})),
      goals: propTypes.arrayOf(propTypes.shape({})),
      files: propTypes.arrayOf(propTypes.shape({}))
    })
  ).isRequired,
  goals: propTypes.arrayOf(propTypes.shape({})).isRequired
}

export default DailyOrWeeklyServicesCard
